import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import { isTrowserRollout } from "Intuit/TrowserUtils";

import { SaveButton, RoutedBackButton, BackButton } from "Common/forms/buttons";
import { Row, Col } from "Common/Grid";
import { Nav } from "Common/HTML";
import { SizeSwitch } from "Common/Responsive";
import { SurfaceSection } from "Theme/Surface";

import makeBem from "Utils/makeBem";

const bem = makeBem("NavigationControls");
type Props = {
  backLink?: string;
  saveLink?: string;
  onClickBack?: () => unknown;
  onClickSave?: () => unknown;
  onClickDisabledSave?: () => unknown;
  noBack?: boolean;
  noSave?: boolean;
  backDisabled?: boolean;
  saveDisabled?: boolean;
  submitting?: boolean;
  className?: string;
  saveButtonText?: string;
  useRoutedBackButton?: boolean;
  MiddleContent?: React.ReactNode;
};

const NavigationControls = ({
  backLink,
  saveLink,
  onClickBack,
  onClickSave,
  onClickDisabledSave,
  noBack,
  noSave,
  backDisabled,
  saveDisabled,
  submitting,
  className,
  saveButtonText,
  useRoutedBackButton = true,
  MiddleContent,
}: Props) => {
  let saveBtn = (
    <SaveButton
      my={0}
      className={isIntuit() && isTrowserRollout() ? undefined : "float-right"}
      size="medium"
      type="submit"
      fullWidth
      href={saveLink}
      onClick={onClickSave}
      disabled={saveDisabled}
      submitting={submitting}
      buttonText={<SizeSwitch xs={saveButtonText || "Continue"} md={saveButtonText || "Save and Continue"} />}
    />
  );

  if (saveDisabled) {
    // Hacky way of tracking clicks for on disabled button
    saveBtn = (
      <a
        style={{
          cursor: "default",
        }}
        onClick={onClickDisabledSave}
      >
        {saveBtn}
      </a>
    );
  }

  const BackButtonComponent = useRoutedBackButton ? RoutedBackButton : BackButton;
  const backBtn = <BackButtonComponent href={backLink} onClick={onClickBack} disabled={backDisabled} />;
  return (
    <Nav role="navigation" className={classnames(bem(), "items-center p-6", { [bem("smallNavBtns")]: !!MiddleContent }, className)}>
      {!noBack && (
        <Col xs={MiddleContent ? 2 : 6} sm={3} className="px-0 sm:text-left">
          {backBtn}
        </Col>
      )}
      {MiddleContent && (
        <Col xs={3} sm={5} className={classnames("px-0", { "sm:text-left": !!noBack })}>
          {MiddleContent}
        </Col>
      )}
      {!noSave && (
        <Col xs={6} sm={4} className="text-right px-0">
          {saveBtn}
        </Col>
      )}
    </Nav>
  );
};

export default NavigationControls;
